import React, { useState } from 'react';
import './Header.css';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ProfilePopup from './ProfilePopup/ProfilePopup';
import { useAuth } from './../../AuthProvider';
import { useApp } from '../../AppProvider';
import { Avatar } from '@mui/material';

const Header = () => {
    const { user } = useAuth();
    const { stringAvatar, stringToColor, selectedClinic } = useApp();
    const [openModalProfilePopup, setOpenModalProfilePopup] = useState(false);

    // console.log("Header user ====>", user); 

    return (
        <>
            <div className='header_container'>
                <h2 className='clinic__name-section'>{selectedClinic?.name?.fullName || 'Null'}</h2>
                <div className="profile-section" onClick={() => setOpenModalProfilePopup(true)}>
                    <Avatar
                        sx={{
                            width: { md: 40, lg: 50, xl: 55 },
                            height: { md: 40, lg: 50, xl: 55 },
                            bgcolor: user.img ? 'transparent' : stringToColor(user.name.firstName),
                        }}
                        alt={user.name.firstName}
                        src={user.img}
                    >
                        {!user.img && stringAvatar(`${user.name.firstName}`).children}
                    </Avatar>
                    <div className='dr-title'>
                        <h5>Dr. {`${user.name.firstName || ""} ${user.name.middleName || ""} ${user.name.lastName || ""}`}</h5>
                        <div className='profile-spacialization_tag'>
                            <span>{user.specilizations.join(", ")}</span>
                            {/* <marquee scrollamount="1">{user.specilizations.join(", ")}</marquee> */}
                        </div>
                    </div>
                    <ExpandMoreIcon className='downArrowIcon' />
                </div>
            </div>
            {openModalProfilePopup && <ProfilePopup onClose={() => setOpenModalProfilePopup(false)} />}
        </>
    );
}

export default Header;
